import { Component, computed } from '@angular/core';
import { hostBinding } from 'ngxtension/host-binding';

@Component({
    selector: 'story-card',
    template: `
        <article class="@2xl:flex-row flex h-full w-full flex-col">
            <div class="@2xl:w-1/2 flex-none empty:hidden">
                <ng-content select="story-image"></ng-content>
            </div>
            <div class="@2xl:gap-3 flex flex-grow flex-col gap-2 p-6 md:p-8">
                <div class="ml-[-3px] flex-none empty:hidden">
                    <ng-content select="aui-icon"></ng-content>
                    <ng-content select="story-icon"></ng-content>
                </div>
                <div class="flex-none empty:hidden">
                    <ng-content select="story-title"></ng-content>
                </div>

                <div class="flex-grow empty:hidden">
                    <ng-content select="story-description"></ng-content>
                </div>

                <div class="flex-none pt-4 empty:hidden">
                    <ng-content select="aui-button"></ng-content>
                    <ng-content select="story-cta"></ng-content>
                    <ng-content select="a"></ng-content>
                </div>

                <ng-content></ng-content>
            </div>
        </article>
    `,
})
export class StoryCardComponent {
    hostClass = hostBinding(
        'attr.class',
        computed(() => '@container block h-full w-full overflow-hidden rounded border border-surface-background-darker')
    );
}
